import type {
  FormContextPreference,
  ScreenContextPreference,
} from "../stores/chat";
import type { ScreenContext } from "@/types";
import { detectScreenReference } from "../hooks/useScreenContextDetection";

export interface ContextConsentState {
  includeScreenContext: boolean | null;
  screenContextPreference: ScreenContextPreference;
  includeFormContext: boolean | null;
  formContextPreference: FormContextPreference;
}

export function shouldAskForScreenContext(
  message: string,
  screenContext: ScreenContext | undefined,
  state: Pick<
    ContextConsentState,
    "includeScreenContext" | "screenContextPreference"
  >,
): boolean {
  return (
    screenContext != null &&
    state.screenContextPreference === "ask" &&
    state.includeScreenContext == null &&
    detectScreenReference(message, screenContext)
  );
}

export function resolveContextInclusion(
  state: ContextConsentState,
  hasFormContext: boolean,
): { includeScreenContext: boolean; includeFormContext: boolean } {
  const includeScreenContext =
    state.includeScreenContext === false
      ? false
      : state.includeScreenContext === true ||
        state.screenContextPreference === "always";
  return {
    includeScreenContext,
    includeFormContext:
      hasFormContext &&
      state.includeFormContext !== false &&
      state.formContextPreference !== "never" &&
      (includeScreenContext ||
        state.includeFormContext === true ||
        state.formContextPreference === "always"),
  };
}
